module.exports = __webpack_public_path__ + "static/media/img-102.cacdbda1.png";